/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_No_Remote_CodeInputs */

const en_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No remote code`)
};

const ar_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا كود عن بُعد`)
};

const bn_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নো রিমোট কোড`)
};

const de_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Remote-Code`)
};

const es_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin código remoto`)
};

const fr_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de code à distance`)
};

const pt_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem código remoto`)
};

const zh_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无远程代码`)
};

const tr_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzaktan kod yok`)
};

const ru_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет удаленного кода`)
};

const pl_svchip_no_remote_code = /** @type {(inputs: Svchip_No_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak kodu zdalnego`)
};

/**
* | output |
* | --- |
* | "No remote code" |
*
* @param {Svchip_No_Remote_CodeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_no_remote_code = /** @type {((inputs?: Svchip_No_Remote_CodeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_No_Remote_CodeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_no_remote_code(inputs)
	if (locale === "bn") return bn_svchip_no_remote_code(inputs)
	if (locale === "de") return de_svchip_no_remote_code(inputs)
	if (locale === "es") return es_svchip_no_remote_code(inputs)
	if (locale === "fr") return fr_svchip_no_remote_code(inputs)
	if (locale === "pt") return pt_svchip_no_remote_code(inputs)
	if (locale === "zh") return zh_svchip_no_remote_code(inputs)
	if (locale === "tr") return tr_svchip_no_remote_code(inputs)
	if (locale === "ru") return ru_svchip_no_remote_code(inputs)
	if (locale === "pl") return pl_svchip_no_remote_code(inputs)
	return en_svchip_no_remote_code(inputs)
});